import { z } from "zod";

export const PartOfSpeechEnum = z
  .enum([
    "noun",
    "verb",
    "adjective",
    "adverb",
    "pronoun",
    "preposition",
    "conjunction",
    "interjection",
    "article",
  ])
  .nullable();

export const VocabCardSchema = z
  .object({
    _id: z.any(),
    word: z.string(),
    definition: z.string(),
    example: z.string(),
    imageId: z.any().nullable(),
    imageKey: z.string().nullable().optional(),
    audioId: z.any().nullable(),
    audioKey: z.string().nullable().optional(),
    partOfSpeech: z.string().nullable(),
  })
  .transform((vocabCard) => ({
    ...vocabCard,
    id: vocabCard._id.toString(),
    imageId: vocabCard.imageId?.toString() ?? null,
    imageKey: vocabCard.imageKey ?? null,
    audioId: vocabCard.audioId?.toString() ?? null,
    audioKey: vocabCard.audioKey ?? null,
    partOfSpeech: PartOfSpeechEnum.safeParse(vocabCard.partOfSpeech).success
      ? vocabCard.partOfSpeech
      : null,
  }));

export type VocabCard = z.infer<typeof VocabCardSchema>;
